import { render } from "./MenuNavBarItem.vue?vue&type=template&id=1ebe345c&lang=pug"
import script from "./MenuNavBarItem.vue?vue&type=script&lang=js"
export * from "./MenuNavBarItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/menu/MenuNavBarItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ebe345c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ebe345c', __exports__)) {
    api.reload('1ebe345c', __exports__)
  }
  
  module.hot.accept("./MenuNavBarItem.vue?vue&type=template&id=1ebe345c&lang=pug", () => {
    api.rerender('1ebe345c', render)
  })

}


export default __exports__